import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ManIcon from '@mui/icons-material/Man';
import AddIcon from '@mui/icons-material/Add';
import WomanIcon from '@mui/icons-material/Woman';
import {
    Dialog, DialogContent, useMediaQuery,
    useTheme, TextField, Stack, Chip, InputAdornment, DialogActions, Button, Box, Stepper, Step, StepButton, Typography,Card, Grid,Fab
} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import { TransitionProps } from '@mui/material/transitions';
import withHooks from '../../../../utils/withHooks';
import { ApptContext } from '../../contexts/appointment.context';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import { calculateAge } from "../../../../utils/common";
import { AppContext } from '../../../../contexts/app.context';
import appointmentService from '../../../../services/http/appointments/appointment.service';
import { PracticeSesContext } from '../../../practice-session/contexts/practice-session.context';
import dayjs from 'dayjs';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const steps = ['Search Patient', 'Create Appointment'];

export class EditAppointmentModal extends React.Component<any, any, {}> {

    state: any;

    constructor(props: any) {
        super(props);

        this.state = {
            
            open: props.open ?? false,
            phnNumber: '',
            userDetails: [],
            isPhnNumberValid: false,
            isWalkin: false,
            appointmentId: null,
            sessionId: null,
            partyId: null,
            isSaving: false,
            activeStep: 0,
            completed: {},
            formValidation: {
                phnNumber: false
            },
            addDetailsForm: {
                firstname: "",
                lastname: "",
                dob: "",
                age: "",
                height: "",
                weight: "",
                gender: "",
                bp: "",
                hr_spo2: "",
            },
            selectedPatientPartyId: null

        }
    }


    componentWillReceiveProps(nextProps: any) {
        const nextContext = nextProps.apptContext;
        if (!nextContext.editApptModal || (
            this.props.apptContext.editApptModal &&
            this.props.apptContext.editSelectedAppt?.id === nextContext.editSelectedAppt?.id
        )) return;

        const { name, gender, weight, height, age, lastName, dob, userProfileId, partyId, phoneNumber, requestMode, id, practiceSessionId, bp, hr_spo2 } = nextContext.editSelectedAppt;
        const userDetails = {
            firstname: name ?? "",
            lastname: lastName ?? "",
            dob: dob ?? "",
            age: age ?? "",
            height: height ?? "",
            weight: weight ?? "",
            gender: gender ?? "",
            bp: bp ?? "",
            hr_spo2: hr_spo2 ?? ""
        }

        const isWalkin = requestMode === 4;
        // Remove leading zero from phone number if present
        // const cleanPhoneNumber = phoneNumber ? phoneNumber.replace(/^0/, '') : '';

        const phoneStr = phoneNumber ? String(phoneNumber) : '';
        this.setState({ 
            addDetailsForm: userDetails, 
            userProfileId: userProfileId ?? "",
            partyId: partyId ?? null,
            selectedPatientPartyId: null,
            isSaving: false,
            phnNumber: phoneStr,
            isPhnNumberValid: !!(phoneStr && phoneStr.length >= 10),
            isWalkin: isWalkin,
            appointmentId: id,
            sessionId: practiceSessionId,
            activeStep: isWalkin ? 0 : 1
        })
    }

    totalSteps = () => {
        return steps.length;
    };

    completedSteps = () => Object.keys(this.state.completed).length;

    isLastStep = () => this.state.activeStep === this.totalSteps() - 1;

    handleNext = () => {
        if (this.state.activeStep === 0 && !this.state.isPhnNumberValid) {
            this.setState({ formValidation: { phnNumber: true } });
            return;
        }
        const newActiveStep = this.state.activeStep + 1;
        this.setState({ activeStep: newActiveStep });
    }


          validateScreen1 = () => {
        const { selectedDate, selectedSession, selectedSlot } = this.state;
        if (!selectedDate || !selectedSession || !selectedSlot) return false;
        return true
    }
    

    handleBack = () => {
        this.setState({ activeStep: this.state.activeStep - 1, userDetails: [] });
    }


onPhnNumberChange = (e: any) => {
        this.setState({ formValidation: { phnNumber: false } });
        this.setState({ phnNumber: e.target.value });
    }
      getSessionObject = (sessionId: number) => {
        const practiceSession = this.practiceSesContext?.practiceSession || [];
        return practiceSession.find(({practiceSessionId}: any) => practiceSessionId === sessionId);
    }

    handleKeyDown = async (e: any, type: string) => {
        const { phnNumber } = this.state;

        if (type === "enter" && e.key !== 'Enter') return;

        if (isNaN(phnNumber) || phnNumber.length < 10) {
            this.setState({ formValidation: { phnNumber: true } });
            return;
        }

        await this.getPatientDetails();
        this.setState({ isPhnNumberValid: true, formValidation: { phnNumber: false } });
    }


onAddExistingPatient = (idx: number): void => {
    let patientDetails = this.state.userDetails[idx];
    patientDetails = {
        ...patientDetails,
        dob: patientDetails.dob ? dayjs(patientDetails.dob) : patientDetails.dob,
        age: patientDetails.dob ? calculateAge(patientDetails.dob) : ''
    }
    
    this.setState({ 
        isDetailsForm: true, 
        addDetailsForm: patientDetails, 
        patientSelected: idx,
        selectedPatientPartyId: patientDetails.partyId,
        userProfileId: patientDetails.userProfileId || patientDetails.id
    })
}


addDetails = async () => {
    try {
        if (!this.validateAddDetailsForm()) {
            console.warn('⚠️ Form validation failed');
            return;
        }
        
        const { isWalkin, appointmentId, activeStep } = this.state;
        
        // For walk-in appointments at step 0, update the appointment details
        if (isWalkin && activeStep === 0 && appointmentId) {
            console.log('📝 Adding details to walk-in appointment - appointmentId:', appointmentId);
            await this.updateWalkinAppointmentDetails();
            console.log('✅ Walk-in appointment details added successfully');
        } else {
            console.warn('⚠️ Conditions not met for adding details:', { isWalkin, activeStep, appointmentId });
            this.appContext.toast({
                open: true,
                message: 'Unable to add details - invalid state',
                severity: 'warning',
                duration: 2000
            });
        }
    } catch (error) {
        console.error('❌ Error in addDetails:', error);
        this.appContext.toast({
            open: true,
            message: 'Unexpected error while adding details',
            severity: 'error',
            duration: 2000
        });
    }
}

async getPatientDetails(): Promise<any> {
    try {
        const phoneWithPrefix = `0${this.state.phnNumber}`;
        const { data } = await appointmentService.getPatient({ phnNumber: phoneWithPrefix });
        
        console.log('📥 Patient details received:', data);
        
        const mappedData = data?.map((patient: any) => ({
            ...patient,
            userProfileId: patient.userProfileId || patient.id,
            partyId: patient.partyId
        }));
        
        this.setState({
            userDetails: mappedData ?? [],
            isDetailsForm: !this.state.isDetailsForm ? false : !(data.length > 0)
        });
    } catch (error) {
        console.error("❌ getPatient error:", error);
    }
}

updateWalkinAppointmentDetails = async () => {
    const { phnNumber, appointmentId, selectedPatientPartyId } = this.state;
    const patientDetails = JSON.parse(JSON.stringify(this.state.addDetailsForm));

    // Clean up patient details
    Object.keys(patientDetails).forEach((key) => 
        (patientDetails[key] === null || !patientDetails[key]) && delete patientDetails[key]
    );
    
    delete patientDetails.age;
    delete patientDetails.id;
    delete patientDetails.userProfileId;
    delete patientDetails.partyId;
    
    try {
        const phoneStr = String(phnNumber);
        const formattedPhone = phoneStr.startsWith('0') ? phoneStr : `0${phoneStr}`;
        
        // ⭐ Build payload conditionally based on whether patient exists
        const payload: any = {
            id: appointmentId,
            phoneNumber: formattedPhone,
            userProfile: {
                ...patientDetails
            }
        };
        
        // ⭐ Only add partyId if it exists (existing patient)
        if (selectedPatientPartyId) {
            payload.partyId = selectedPatientPartyId;
        }
        // For new patients, don't include partyId at all
        
        console.log('📤 Updating walk-in appointment with payload:', payload);
        
        const { data } = await appointmentService.updateWalkinAppointment(payload);
        
        console.log('✅ API Response:', data);
        
        // Update context with response
        if (data.updatedAppointment) {
            Object.assign(this.apptContext.editSelectedAppt, {
                ...data.updatedAppointment,
                partyId: data.partyId,
                userProfileId: data.updatedAppointment.userProfileId || data.partyId,
                phoneNumber: data.updatedAppointment.phoneNumber
            });
            
            console.log('✅ Context updated with:', this.apptContext.editSelectedAppt);
        }
        
        // Show success message
        this.appContext.toast({ 
            open: true, 
            message: data.message || 'Appointment updated successfully', 
            severity: 'success', 
            duration: 2000 
        });
        
        // Refresh the appointment list
        console.log('🔄 Refreshing appointment list...');
        if (this.apptContext.loadAppointments) {
            await this.apptContext.loadAppointments();
            console.log('✅ Appointment list refreshed');
        } else {
            console.warn('⚠️ loadAppointments not available in context');
        }
        
        // Close modal and reset form
        this.apptContext.setEditApptModal(false);
        
        this.resetForm();
        this.setState({ 
            isDetailsForm: false, 
            userDetails: [],
            patientSelected: null,
            userProfileId: null,
            selectedPatientPartyId: null,
            phnNumber: '',
            isPhnNumberValid: false
        });
        
        console.log('✅ Modal closed and form reset');
        
    } catch (error: any) {
        console.error('❌ Error updating walk-in appointment:', error);
        const errorMessage = error?.response?.data?.message || error?.message || 'Error updating appointment';
        this.appContext.toast({ 
            open: true, 
            message: errorMessage, 
            severity: 'error', 
            duration: 3000 
        });
    }
}

    onFormInputChange = (e: any, attr: string) => {
        let value;
        if (attr !== "gender") {
            value = e.target.value;
            if (attr === "weight" || attr === "height") value = e.target.value === '' ? '' : parseInt(e.target.value);
        }

        const { addDetailsForm } = this.state;
        this.setState({
            addDetailsForm: { ...addDetailsForm, [attr]: attr !== "gender" ? value : e }
        })
    }

    onChangeDate = (date: dayjs.Dayjs | null) => {
        if (date && !date.isValid()) return;
        const dob = date ? date.format('YYYY-MM-DD') : '';
        const { addDetailsForm } = this.state;
        this.setState({
            addDetailsForm: { ...addDetailsForm, dob, age: dob ? calculateAge(dob) : '' }
        })
    }

    validateAddDetailsForm = () => {
        const { addDetailsForm } = this.state;
        if (!addDetailsForm?.firstname) return false;
        return true;
    }


    genderIcon = (gender: string) => {
        if (gender === "male") return <ManIcon />
        if (gender === "female") return <WomanIcon />
    }

    resetForm = (): void => {
        const { addDetailsForm } = this.state;
        Object.keys(addDetailsForm).forEach(function (key) {
            if (key !== "gender") addDetailsForm[key] = "";
        });
        this.setState({ addDetailsForm });
    }

    /**
     * Update user details
     */
    updateApptDetails = async (): Promise<void> => {
        if (this.state.isSaving || !this.validateAddDetailsForm()) return;
        const { setEditApptModal, loadAppointments } = this.apptContext;
        this.setState({ isSaving: true });
        try {
            const form = this.state.addDetailsForm;
            const userDetails: any = { firstname: form.firstname };
            // Omission means "leave unchanged" to the API; null means "clear".
            for (const key of ['lastname', 'gender', 'height', 'weight', 'dob', 'bp', 'hr_spo2']) {
                const value = form[key];
                userDetails[key] = value === '' || value === undefined ? null : value;
            }

            const { message } = await appointmentService.savePatientProfile({
                userProfileId: this.state.userProfileId,
                partyId: this.state.partyId
            }, userDetails);

            this.appContext.toast({
                open: true,
                message: message || 'Patient details saved successfully',
                severity: 'success',
                duration: 2000
            });

            this.resetForm();
            setEditApptModal(false);
            loadAppointments();
        } catch (error: any) {
            console.log("Error in updateApptDetails", error);
            this.appContext.toast({
                open: true,
                message: error?.response?.data?.message || error?.response?.data?.error ||
                    error?.message || 'Unable to save patient details. Please try again.',
                severity: 'warning',
                duration: 2000
            });
        } finally {
            this.setState({ isSaving: false });
        }
    }

    get apptContext() {
        return this.props.apptContext;
    }

    get appContext() {
        return this.props.appContext;
    }

    get practiceSesContext() {
        return this.props.practiceSesContext;
    }


    render(): React.ReactNode {
        const { addDetailsForm, activeStep, isWalkin, userDetails,isPhnNumberValid,isDetailsForm } = this.state;
        const { editApptModal, setEditApptModal } = this.apptContext;

        return <>
            <Dialog
                fullScreen={this.props.isMd}
                open={editApptModal}
                TransitionComponent={Transition}
            >
                <AppBar sx={{
                    width: `${!this.props.isMd ? '500px' : 'auto'}`,
                    position: 'relative',
                    background: 'none',
                    boxShadow: 'none !important',
                    color: 'neutral.900',
                }}>
                    <Toolbar>
                        <Typography sx={{ flex: 1 }} variant="h6" component="div">
                            Edit Appointment
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="close"
                            onClick={() => setEditApptModal(!editApptModal)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <React.Fragment>
                        {isWalkin && (
                            <Stepper nonLinear activeStep={activeStep} sx={{ my: 2 }}>
                                {steps.map((label: string, index: number) => (
                                    <Step key={label} completed={false}>
                                        <StepButton color="inherit">
                                            {label}
                                        </StepButton>
                                    </Step>
                                ))}
                            </Stepper>
                        )}

                        {isWalkin && activeStep === 0 && (
                            <React.Fragment>
                                <TextField
                                    sx={{
                                        mt: 3,
                                        '& .MuiInputBase-input': {
                                            padding: "4%",
                                        }
                                    }}
                                    placeholder='Search phone number'
                                    fullWidth
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">
                                             <IconButton onClick={(e) => this.handleKeyDown(e, "search")}>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>,
                                    }}
                                    helperText={this.state.formValidation.phnNumber ? "Incorrect phone number" : ""}
                                    onChange={this.onPhnNumberChange}
                                    onKeyDown={(e) => this.handleKeyDown(e, 'enter')}
                                    value={this.state.phnNumber}
                                    inputProps={{ maxLength: 10 }}
                                />
                                  {
                                    isPhnNumberValid &&
                                    <React.Fragment>
                                        <Stack
                                            direction="row"
                                            spacing={2} sx={{ mt: 2 }}
                                            alignItems="center"
                                        >
                                            <Typography variant="h6" gutterBottom sx={{ flex: 1, m: 0 }}>
                                                Details
                                            </Typography>
                                            {
                                                !isDetailsForm && <Button
                                                    onClick={() => {
                                                        this.resetForm()
                                                        this.setState({ isDetailsForm: !isDetailsForm })
                                                    }}
                                                    startIcon={<AddIcon />}
                                                    size="small"
                                                >
                                                    New
                                                </Button>
                                            }
                                        </Stack>
                                        {
                                            (!isDetailsForm && !userDetails?.length) ? (
                                                <Box sx={{ textAlign: "left" }}>
                                                    <Typography variant="body1">
                                                        Please add your details
                                                    </Typography>
                                                </Box>
                                            ) : ("")
                                        }
                                        {/**User lists */}
                                        {
                                            !isDetailsForm && userDetails.map((user: any, i: number) => {
                                                return (
                                                    <Stack spacing={2} key={i} sx={{ my: 2 }}>
                                                        <Card
                                                        >
                                                            <Grid container spacing={2} >
                                                                <Grid item xs={9}>
                                                                    <Stack
                                                                        sx={{
                                                                            p: 2
                                                                        }}
                                                                    >
                                                                        <Typography variant="h6" sx={{ fontWeight: '600', mb: 1 }}>
                                                                            {user?.firstname}
                                                                        </Typography>
                                                                        <Typography variant="subtitle1" sx={{ fontWeight: '400' }}>
                                                                            Physique
                                                                        </Typography>
                                                                        <Typography variant="subtitle2" sx={{ fontWeight: '600' }}>
                                                                            {user?.gender} | Age - {user?.age} |  W - {user?.weight}kg | H - {user?.height}Cm
                                                                        </Typography>
                                                                    </Stack>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                    <Stack
                                                                        alignItems={"center"}
                                                                        sx={{
                                                                            py: 3
                                                                        }}>
                                                                        <Fab color="primary" aria-label="add" size="small" onClick={() => this.onAddExistingPatient(i)}>
                                                                            <AddIcon />
                                                                        </Fab>
                                                                    </Stack>
                                                                </Grid>
                                                            </Grid>
                                                        </Card>
                                                    </Stack>
                                                )
                                            })
                                        }

                                        {/**Details form */}
                                        {
                                            isDetailsForm && <React.Fragment>
                                                <TextField
                                                    sx={{
                                                        mt: 1,
                                                        '& .MuiInputBase-input': {
                                                            padding: "4%",
                                                        }
                                                    }}
                                                    onChange={(e) => this.onFormInputChange(e, "firstname")}
                                                    value={addDetailsForm.firstname}
                                                    placeholder='First Name'
                                                    fullWidth
                                                />
                                                <TextField
                                                    sx={{
                                                        mt: 2,
                                                        '& .MuiInputBase-input': {
                                                            padding: "4%",
                                                        }
                                                    }}
                                                    onChange={(e) => this.onFormInputChange(e, "lastname")}
                                                    value={addDetailsForm.lastname}
                                                    placeholder='Last name'
                                                    fullWidth
                                                />
                                                <Stack
                                                    direction="row"
                                                    spacing={2} sx={{ mt: 2 }}
                                                >
                                                    {
                                                        [{ name: "male", key: "M" }, { name: "female", key: "F" }, { name: "others", key: "O" }].map((gndr: any) => {
                                                            return <Chip
                                                                onClick={() => this.onFormInputChange(gndr.key, "gender")}
                                                                key={gndr.key}
                                                                icon={this.genderIcon(gndr.name)}
                                                                label={gndr.name}
                                                                {...(addDetailsForm?.gender !== gndr.key ? { variant: 'outlined' } : {})}
                                                            />
                                                        })
                                                    }
                                                </Stack>

                                                <Stack spacing={2} direction="row" sx={{ mt: 2 }}>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                                                        <DateField
                                                            format="DD-MM-YYYY"
                                                            onChange={this.onChangeDate}
                                                            value={addDetailsForm.dob ? dayjs(addDetailsForm.dob) : null}
                                                            sx={{
                                                                '& .MuiInputBase-input': {
                                                                    padding: "9%",
                                                                },
                                                                flex: '1 1 0',
                                                                width: '0',
                                                            }} />
                                                    </LocalizationProvider>
                                                    <TextField
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                padding: "9%",
                                                            },
                                                            flex: '1 1 0',
                                                            width: '0',
                                                        }}
                                                        placeholder='Age'
                                                        type='number'
                                                        inputProps={{ maxLength: 3 }}
                                                        onChange={(e) => this.onFormInputChange(e, "age")}
                                                        value={addDetailsForm.age}
                                                    />
                                                </Stack>
                                                <Stack spacing={2} direction="row" sx={{ mt: 2 }}>
                                                    <TextField
                                                        className="user-wh-details"
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                padding: "9%",
                                                            },
                                                            flex: '1 1 0',
                                                            width: '0',
                                                        }}
                                                        placeholder='Height'
                                                        type='number'
                                                        InputProps={{
                                                            endAdornment: <InputAdornment position="end">Cm</InputAdornment>,
                                                        }}
                                                        onChange={(e) => this.onFormInputChange(e, "height")}
                                                        value={addDetailsForm.height}
                                                    />
                                                    <TextField
                                                        className="user-wh-details"
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                padding: "9%",
                                                            },
                                                            flex: '1 1 0',
                                                            width: '0',
                                                        }}
                                                        placeholder='Weight'
                                                        type='number'
                                                        InputProps={{
                                                            endAdornment: <InputAdornment position="end">Kg</InputAdornment>,
                                                        }}
                                                        inputProps={{ maxLength: 3 }}
                                                        onChange={(e) => this.onFormInputChange(e, "weight")}
                                                        value={addDetailsForm.weight}
                                                    />
                                                </Stack>
                                                <Stack spacing={2} direction="row" sx={{ mt: 2 }}>
                                                    <TextField
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                padding: "9%",
                                                            },
                                                            flex: '1 1 0',
                                                            width: '0',
                                                        }}
                                                        placeholder='BP'
                                                        onChange={(e) => this.onFormInputChange(e, "bp")}
                                                        value={addDetailsForm.bp}
                                                    />
                                                    <TextField
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                padding: "9%",
                                                            },
                                                            flex: '1 1 0',
                                                            width: '0',
                                                        }}
                                                        placeholder='HR / SpO2'
                                                        onChange={(e) => this.onFormInputChange(e, "hr_spo2")}
                                                        value={addDetailsForm.hr_spo2}
                                                    />
                                                </Stack>

                                                {/* <DialogActions sx={{ mt: '1rem' }}>
                                                    <Button onClick={() => this.setState({ isDetailsForm: !isDetailsForm })}>Cancel</Button>
                                                    <Button
                                                        onClick={() => this.addDetails()}
                                                        disabled={!(this.validateAddDetailsForm())}
                                                    >
                                                        Add
                                                    </Button>
                                                </DialogActions> */}
                                            </React.Fragment>
                                        }

                                         <Box sx={{ display: 'flex', flexDirection: 'row', pt: 5 }}>
                            {/* {
                                this.state.activeStep > 0 && <Button
                                    size="small"
                                    color="inherit"
                                    disabled={this.state.activeStep === 0}
                                    startIcon={<ArrowBackIcon />}
                                    onClick={this.handleBack}
                                    sx={{ mr: 1 }}
                                >
                                    Prev
                                </Button>
                            } */}
                            <Box sx={{ flex: '1 1 auto' }} />
                        </Box>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        )}

                        {(!isWalkin || activeStep === 1) && (
                            <React.Fragment>
                                <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>Details</Typography>
                                <TextField
                                    sx={{
                                        '& .MuiInputBase-input': {
                                            padding: "4%",
                                        }
                                    }}
                                    onChange={(e) => this.onFormInputChange(e, "firstname")}
                                    value={addDetailsForm.firstname}
                                    placeholder='First Name'
                                    fullWidth
                                />
                                <TextField
                                    sx={{
                                        mt: 2,
                                        '& .MuiInputBase-input': {
                                            padding: "4%",
                                        }
                                    }}
                                    onChange={(e) => this.onFormInputChange(e, "lastname")}
                                    value={addDetailsForm.lastname}
                                    placeholder='Last name'
                                    fullWidth
                                />
                                <Stack
                                    direction="row"
                                    spacing={2} sx={{ mt: 2 }}
                                >
                                    {
                                        [{ name: "male", key: "M" }, { name: "female", key: "F" }, { name: "others", key: "O" }].map((gndr: any) => {
                                            return <Chip
                                                onClick={() => this.onFormInputChange(gndr.key, "gender")}
                                                key={gndr.key}
                                                icon={this.genderIcon(gndr.name)}
                                                label={gndr.name}
                                                {...(addDetailsForm?.gender !== gndr.key ? { variant: 'outlined' } : {})}
                                            />
                                        })
                                    }
                                </Stack>

                                <Stack spacing={2} direction="row" sx={{ mt: 2 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                                        <DateField
                                            disabled={false}
                                            format="DD-MM-YYYY"
                                            onChange={this.onChangeDate}
                                            value={addDetailsForm.dob ? dayjs(addDetailsForm.dob) : null}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    padding: "9%",
                                                },
                                                flex: '1 1 0',
                                                width: '0',
                                            }} />
                                    </LocalizationProvider>
                                    <TextField
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: "9%",
                                            },
                                            flex: '1 1 0',
                                            width: '0',
                                        }}
                                        disabled
                                        placeholder='Age'
                                        type='number'
                                        inputProps={{ maxLength: 3 }}
                                        onChange={(e) => this.onFormInputChange(e, "age")}
                                        value={addDetailsForm.age}
                                    />
                                </Stack>
                                <Stack spacing={2} direction="row" sx={{ mt: 2 }}>
                                    <TextField
                                        className="user-wh-details"
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: "9%",
                                            },
                                            flex: '1 1 0',
                                            width: '0',
                                        }}
                                        placeholder='Height'
                                        type='number'
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">Cm</InputAdornment>,
                                        }}
                                        onChange={(e) => this.onFormInputChange(e, "height")}
                                        value={addDetailsForm.height}
                                    />
                                    <TextField
                                        className="user-wh-details"
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: "9%",
                                            },
                                            flex: '1 1 0',
                                            width: '0',
                                        }}
                                        placeholder='Weight'
                                        type='number'
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">Kg</InputAdornment>,
                                        }}
                                        inputProps={{ maxLength: 3 }}
                                        onChange={(e) => this.onFormInputChange(e, "weight")}
                                        value={addDetailsForm.weight}
                                    />
                                </Stack>
                                <Stack spacing={2} direction="row" sx={{ mt: 2 }}>
                                    <TextField
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: "9%",
                                            },
                                            flex: '1 1 0',
                                            width: '0',
                                        }}
                                        placeholder='BP'
                                        onChange={(e) => this.onFormInputChange(e, "bp")}
                                        value={addDetailsForm.bp}
                                    />
                                    <TextField
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: "9%",
                                            },
                                            flex: '1 1 0',
                                            width: '0',
                                        }}
                                        placeholder='HR / SpO2'
                                        onChange={(e) => this.onFormInputChange(e, "hr_spo2")}
                                        value={addDetailsForm.hr_spo2}
                                    />
                                </Stack>
                            </React.Fragment>
                        )}
                         {isWalkin && activeStep === 0 && isDetailsForm &&
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 5 }}>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={() => this.setState({ isDetailsForm: false })}>Cancel</Button>
                            <Button
                                size="small"
                                variant="contained"
                                onClick={() => this.addDetails()}
                                disabled={!(this.validateAddDetailsForm())}
                                sx={{ ml: '5px' }}
                            >
                                Add
                            </Button>
                        </Box>
                        }
    


                       <DialogActions sx={{ mt: '1rem' }}>
                         {
                                this.state.activeStep === 1 && <>
                            <Button onClick={() => setEditApptModal(!editApptModal)}>Cancel</Button>
                            <Button
                                onClick={() => this.updateApptDetails()}
                                disabled={this.state.isSaving || !(this.validateAddDetailsForm())}
                            >
                                {this.state.isSaving ? 'Saving...' : 'Save'}
                            </Button>
                              </>
                            }
                        </DialogActions>
                        
                    </React.Fragment>
                </DialogContent>
            </Dialog>
        </>
    }
}

export default withHooks(EditAppointmentModal, [
    ['isMd', (() => useMediaQuery((theme: any) => theme.breakpoints.down('md')))],
    ['apptContext', React.useContext, [ApptContext]],
    ['appContext', React.useContext, [AppContext]],
    ['practiceSesContext', React.useContext, [PracticeSesContext]],
    ['theme', useTheme]
]);
